import type { RegistryRow, ValueRow } from '../types/bsc';
import { evaluateStatus } from '../lib/status';
import { formatDisplayValue } from '../lib/formatters';
import { formatItalianDate } from '../lib/dates';
import { StatusBadge } from './StatusBadge';

interface BreakdownTableProps {
  rows: ValueRow[];
  registry: RegistryRow;
}

export function BreakdownTable({ rows, registry }: BreakdownTableProps) {
  const tableRows = rows
    .filter((row) => row.dimension_value.toLocaleLowerCase('it-IT') !== 'totale')
    .sort(
      (a, b) =>
        a.dimension_value.localeCompare(b.dimension_value, 'it') ||
        a.period.localeCompare(b.period),
    );

  if (tableRows.length === 0) return null;

  return (
    <div className="breakdown-block">
      <div className="section-heading-inline">
        <div>
          <h4>Dettaglio per {registry.Raggruppamento || 'categoria'}</h4>
          <p>{tableRows.length} osservazioni storiche</p>
        </div>
      </div>
      <div className="table-scroll">
        <table className="data-table">
          <thead>
            <tr>
              <th>Periodo</th>
              <th>Categoria</th>
              <th>Valore</th>
              <th>Stato</th>
              <th>Origine</th>
              <th>Nota</th>
            </tr>
          </thead>
          <tbody>
            {tableRows.map((row) => {
              const status = evaluateStatus({
                value: row.value,
                Target: registry.Target,
                Soglia_Minima: registry.Soglia_Minima,
                Soglia_Eccellenza: registry.Soglia_Eccellenza,
                Trend_Desiderato: registry.Trend_Desiderato,
              });
              return (
                <tr key={`${row.period}-${row.dimension_type}-${row.dimension_value}-${row.source_order}`}>
                  <td>{formatItalianDate(row.period)}</td>
                  <td>
                    <strong>{row.dimension_value}</strong>
                    <small>{row.dimension_type}</small>
                  </td>
                  <td>{formatDisplayValue(row.value, registry.Unità_di_Misura)}</td>
                  <td>
                    <StatusBadge status={status} compact />
                  </td>
                  <td>{row.source_file || row.record_type}</td>
                  <td>{row.note || '—'}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
